<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path
      d="M22.0956 29.5833L14.9797 22.4674L7.8753 29.5719L0.450034 22.1466L7.55447 15.0421L0.417969 7.90564L7.90698 0.416626L15.0435 7.55313L22.1277 0.468933L29.553 7.8942L22.4688 14.9784L29.5846 22.0943L22.0956 29.5833Z"
      fill="currentColor"
    />
  </svg>
</template>
